module.exports = __webpack_public_path__ + "static/media/logo_aiPlato-white-h.d14b7be4.png";